export default __webpack_public_path__ + "static/media/moon.de512d51.svg";